import React, { useEffect, useMemo, useState } from "react";
import { NavLink, useParams } from "react-router-dom";
import axios from "axios";

import {
	addToast,
	Autocomplete,
	AutocompleteItem,
	Avatar,
	Button,
	Card,
	CardBody,
	CardHeader,
	Checkbox,
	Modal,
	ModalBody,
	ModalContent,
	ModalFooter,
	ModalHeader,
	Select,
	SelectItem,
	Tooltip,
	useDisclosure,
	Pagination,
	Tabs,
	Tab,
	Listbox,
	ListboxItem,
	Chip,
	Spinner,
	ScrollShadow,
	Progress,
	User,
} from "@heroui/react";
import HoverMedals from "../../components/HoverMedals";
import { HeatContent } from "../../components/HeatChart";
import { useNavigate } from "react-router";
import MixToolTip from "../../components/MixToolTip";
import ActionTable from "../../components/ActionTable2";
import AmountDialog from "./AmountDialog";
import LiveCard from "./LiveCard";
import RankList from "./RankList";
import RankBlock from "./RankBlock";
import { calcAmount } from "./calc.js";

function UserPage(props) {
	let { id } = useParams();
	const [space, setSpace] = useState({});
	const [spaceLoading, setSpaceLoading] = useState(true);
	const [actionLoading, setActionLoading] = useState(true);
	const [initialActionLoaded, setInitialActionLoaded] = useState(false);
	const redirect = useNavigate();
	useEffect(() => {
		const nums = id.match(/\d+/g)?.[0];
		if (nums !== id) {
			redirect("/user/" + nums);
		} else {
			setSpaceLoading(true);
			axios
				.get(`/api/user/space?uid=${id}`)
				.then((response) => {
					setSpace(response.data);
					setFilteredRooms(response.data.Rooms);
					document.title = response.data.UName + " 的弹幕数据";
					console.log(response.data);
				})
				.catch((err) => {
					console.error(err);
				})
				.finally(() => {
					setSpaceLoading(false);
				});
			axios
				.get("/api/🐱icu/replies?only_cnt=1&uid=" + id)
				.then((response) => {
					setReplyCount(response.data.cnt);
				});
		}

		return () => {
			document.title = "Vtuber 数据";
		};
	}, []);
	const [total, setTotal] = useState(1);
	const [data, setData] = useState([]);

	const [filter, setFilter] = useState("");

	const [order, setOrder] = useState("");

	const [room, setRoom] = useState("");

	const [input, setInput] = useState("");

	const [showMedal, setShowMedal] = useState(false);

	const [showEnter, setShowEnter] = useState(false);

	const [replyCount, setReplyCount] = useState(0);

	const [cardView, setCardView] = useState(
		(function () {
			if (localStorage.getItem("cardView") === null) {
				localStorage.setItem("cardView", "true");
				return true;
			}
			return localStorage.getItem("cardView") === "true";
		})(),
	);
	let page = 1;

	useEffect(() => {
		setActionLoading(true);
		axios
			.get(
				`/api/actions?pb=1&uid=${id}&pn=${page}&ps=${localStorage.getItem("defaultPageSize")}&order=${order}&type=${filter}&room=${room === null ? "" : room} &enter=${showEnter ? "1" : ""} `,
			)
			.then((response) => {
				if (response.data.items) {
					response.data.items.forEach((item, index) => {
						if (showEnter) {
							response.data.items[index].extra = "进入直播间";
							response.data.items[index].id =
								response.data.items[index].liver_id +
								response.data.items[index].created_at.seconds +
								index;
						}
					});
				}

				setData(response.data.items);
				setTotal(response.data.total);
				setRaw(response.data);

				if (response.data.total === 0) {
					if (filter === "") {
						setNoFound(response.data.total === 0);
						addToast({
							title: "没有数据喵",
							color: "danger",
						});
					}
				}
			})
			.catch((err) => {
				console.error(err);
			})
			.finally(() => {
				setActionLoading(false);
				setInitialActionLoaded(true);
			});
	}, [order, filter, room, showEnter]);

	const tableRef = React.useRef();

	const [noFound, setNoFound] = useState(false);

	const roomMsgRank = useMemo(() => {
		if (!space.Rooms || !Array.isArray(space.Rooms)) return [];
		return [...space.Rooms]
			.map((item) => {
				return {
					...item,
					CountNode: item.Count.toLocaleString() + "条",
				};
			})
			.filter((item) => (item.Rate ?? 0) > 0 || (item.Count ?? 0) > 0)
			.sort((a, b) => (b.Count ?? b.Rate) - (a.Count ?? a.Rate));
	}, [space.Rooms]);

	const roomAmountRank = calcAmount(space);

	const [raw, setRaw] = useState({});

	const historyList = useMemo(() => {
		if (!space.HistoryName || !Array.isArray(space.HistoryName)) return [];
		const sorted = [...space.HistoryName]
			.filter(
				(item) =>
					item &&
					(item.u_name || item.from_name) &&
					item.u_name !== "哔哩哔哩用户" &&
					item.from_name !== "哔哩哔哩用户",
			)
			.sort(
				(a, b) =>
					new Date(a.update_at || a.created_at || 0) -
					new Date(b.update_at || b.created_at || 0),
			);
		return sorted.filter((item, index) => {
			if (index === 0) return true;
			const prev = sorted[index - 1];
			const prevName = prev.u_name || prev.from_name || "";
			const currName = item.u_name || item.from_name || "";
			const prevFace = prev.face || "";
			const currFace = item.face || "";
			return prevName !== currName || prevFace !== currFace;
		});
	}, [space.HistoryName]);

	const hasHistoryChange = useMemo(() => {
		return (
			historyList.length > 1 ||
			(historyList.length === 1 && historyList[0].u_name !== space.UName)
		);
	}, [historyList, space.UName]);

	const rootRef = React.useRef();

	const [pageStat, setPage] = useState(0);

	const [showMsgList, setShowMsgList] = useState(false);

	const [tab, setTab] = useState("msg");

	return (
		<div>
			{/*            <Modal isOpen={isOpen} onOpenChange={onOpenChange} size="2xl">
                <ModalContent>
                    {(onClose) => (
                        <>
                            <ModalHeader className="flex flex-col gap-1">
                                Modal Title
                            </ModalHeader>
                            <ModalBody>
                                <HeatContent uid={id} />
                            </ModalBody>
                            <ModalFooter>
                                <Button
                                    color="danger"
                                    variant="light"
                                    onPress={onClose}
                                >
                                    Close
                                </Button>
                                <Button color="primary" onPress={onClose}>
                                    Action
                                </Button>
                            </ModalFooter>
                        </>
                    )}
                </ModalContent>
            </Modal>*/}

			<Modal
				isOpen={showMsgList}
				onOpenChange={setShowMsgList}
				size="2xl"
				classNames={{
					body: "p-0",
				}}
			>
				<ModalContent>
					<ModalBody className={"!w-full "}>
						<RankBlock
							loading={spaceLoading}
							roomMsgRank={roomMsgRank}
							roomAmountRank={roomAmountRank}
							currentRoom={room}
							onRoomChange={(e) => {
								setRoom(e);
								setPage(1);
							}}
							box={space.Box}
							guard={space.Guard}
							tab={tab}
						/>
					</ModalBody>
				</ModalContent>
			</Modal>

			{!noFound && (
				<div className="flex flex-col sm:flex-row gap-4 h-auto sm:h-[88vh]">
					{!isMobile() && (
						<div className="sm:w-[25vw]  relative self-start flex-shrink-0">
							<RankBlock
								loading={spaceLoading}
								roomMsgRank={roomMsgRank}
								roomAmountRank={roomAmountRank}
								currentRoom={room}
								onRoomChange={(e) => {
									setRoom(e);
									setPage(1);
								}}
								box={space.Box}
								guard={space.Guard}
							/>
						</div>
					)}
					<div
						className={"flex-1 min-w-0 lg:overflow-x-hidden "}
						ref={rootRef}
					>
						<div className="relative min-h-[140px]">
							{spaceLoading && (
								<div className="absolute inset-0 flex items-center justify-center z-10">
									<Spinner label="加载用户基本信息..." />
								</div>
							)}
							<div
								className={`transition-all duration-300 ease-out ${
									spaceLoading
										? "opacity-0 translate-y-1 pointer-events-none"
										: "opacity-100 translate-y-0"
								}`}
								style={{ willChange: "opacity, transform" }}
							>
								<div className="grid grid-cols-1 sm:grid-cols-3 gap-2 text-sm">
									<MixToolTip
										content={
											<div className="max-h-[360px] overflow-y-auto px-1 py-1 text-sm">
												{historyList.length > 0 ? (
													historyList.map(
														(item, index) => {
															const time =
																item.update_at ||
																item.created_at;
															const dateStr = time
																? new Date(
																		time,
																	).toLocaleDateString()
																: "";
															const name =
																item.u_name ||
																item.from_name ||
																"";
															return (
																<div
																	key={
																		item.id ||
																		index
																	}
																	className={
																		index >
																		0
																			? "mt-3"
																			: ""
																	}
																>
																	<p className="text-gray-400">
																		{
																			dateStr
																		}
																	</p>
																	<div className="flex items-center mt-0.5">
																		{item.face && (
																			<Avatar
																				src={
																					item.face
																				}
																				alt=""
																				className="rounded-full object-cover inline-block ring-1 ring-zinc-300 dark:ring-zinc-700 shrink-0"
																				onError={(
																					e,
																				) => {
																					e.target.style.display =
																						"none";
																				}}
																			/>
																		)}
																		<span
																			className={
																				"ml-1"
																			}
																		>
																			{
																				name
																			}
																		</span>
																	</div>
																</div>
															);
														},
													)
												) : (
													<div>
														<p className="text-gray-400">
															{space.FirstSeen
																? new Date(
																		space.FirstSeen,
																	).toLocaleDateString()
																: "当前昵称"}
														</p>
														<div className="flex items-center mt-0.5">
															<span className="ml-1">
																{space.UName}
															</span>
														</div>
													</div>
												)}
												<div className="mt-3 pt-2 border-t border-zinc-200 dark:border-zinc-700/60 flex items-center justify-between text-xs gap-3">
													<span className="text-gray-400 font-mono">
														UID: {id}
													</span>
													<a
														href={`https://space.bilibili.com/${id}`}
														target="_blank"
														rel="noreferrer"
														className="text-blue-500 hover:text-blue-600 dark:text-blue-400 flex items-center gap-1 hover:underline font-medium"
														onClick={(e) => {
															e.stopPropagation();
														}}
													>
														<span>进入空间</span>
														<svg
															className="w-3.5 h-3.5"
															viewBox="0 0 24 24"
															fill="none"
															stroke="currentColor"
															strokeWidth="2"
															strokeLinecap="round"
															strokeLinejoin="round"
														>
															<path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
															<polyline points="15 3 21 3 21 9"></polyline>
															<line
																x1="10"
																y1="14"
																x2="21"
																y2="3"
															></line>
														</svg>
													</a>
												</div>
											</div>
										}
									>
										<div className="p-2 rounded-xl transition-colors duration-150 cursor-pointer dark:bg-[#18181b] dark:hover:bg-[#232326] bg-zinc-50 hover:bg-zinc-100">
											<div
												className="flex flex-row items-center dark:text-stone-100"
												onClick={() => {
													if (!isMobile()) {
														toSpace(id);
													}
												}}
											>
												<img
													src={`${AVATAR_API}${id}`}
													className="w-12 h-12 ml-4 mr-4 rounded-full ring-1 ring-zinc-200 dark:ring-zinc-700"
												/>
												{space.UName}
											</div>
										</div>
									</MixToolTip>
									<div
										className="rounded-xl dark:bg-[#18181b] dark:hover:bg-[#232326] p-2 transition-colors duration-150 cursor-pointer bg-zinc-50 hover:bg-zinc-100"
										//onClick={}
									>
										首次出现
										<br />
										<span className="font-semibold">
											{space.FirstSeen
												? new Date(
														space.FirstSeen,
													).toLocaleString()
												: "-"}
										</span>
									</div>
									<div className="rounded-xl dark:bg-[#18181b] p-2 transition-colors duration-150 bg-zinc-50 hover:bg-zinc-100">
										最后出现
										<br />
										<span className="font-semibold">
											{space.LastSeen
												? new Date(
														space.LastSeen,
													).toLocaleString()
												: "-"}
										</span>
									</div>
								</div>
								<div
									className={
										"grid  grid-cols-1 sm:grid-cols-3 gap-2 text-sm mt-4"
									}
								>
									<div className="rounded-xl bg-blue-50 dark:bg-[#18181b] p-2 transition-colors duration-150 flex flex-row">
										<div
											onClick={() => {
												if (!isMobile()) {
													return;
												}
												setShowMsgList(true);
											}}
											className={
												"w-[50%] h-full relative cursor-pointer hover:bg-blue-100/70 active:bg-blue-200/60 dark:hover:bg-[#232326] rounded transition-colors duration-150"
											}
										>
											弹幕
											<br />
											<span className="font-semibold">
												{space.Message}
											</span>
											<svg
												className="absolute bottom-0.5 right-0.5 w-3.5 h-3.5 text-blue-400 dark:text-blue-500 pointer-events-none block sm:hidden"
												viewBox="0 0 24 24"
												fill="none"
												stroke="currentColor"
												strokeWidth="2.5"
												strokeLinecap="round"
												strokeLinejoin="round"
											>
												<polyline points="9 18 15 12 9 6" />
											</svg>
										</div>

										<div className="border-l-1 border-dashed border-blue-300 dark:border-zinc-700 mx-3 self-stretch " />

										<div
											className={
												"w-[50%] h-full cursor-pointer hover:bg-blue-100/70 dark:hover:bg-[#232326] rounded transition-colors duration-150"
											}
											onClick={() => {
												window.open(
													"https://vtb.dog/replies?uid=" +
														id,
												);
											}}
										>
											评论
											<br />
											<span className="font-semibold">
												{replyCount}
											</span>
										</div>
									</div>
									<Tooltip
										content={
											<div>
												<p>
													大航海：
													{space.GuardMoney &&
														space.GuardMoney.toLocaleString()}
												</p>
												<p>
													礼物/SC：
													{space.GiftMoney &&
														space.GiftMoney.toLocaleString()}
												</p>
											</div>
										}
									>
										<div
											onClick={() => {
												if (!isMobile()) {
													return;
												}
												setShowMsgList(true);
												setTab("money");
											}}
											className="rounded-xl bg-yellow-50 relative dark:bg-[#18181b] p-2 transition-colors duration-150 hover:bg-yellow-100 dark:hover:bg-[#232326] cursor-pointer"
										>
											消费
											<br />
											<span className="font-semibold">
												{(
													(space.GiftMoney || 0) +
													(space.GuardMoney || 0)
												).toLocaleString()}
											</span>
											<svg
												className="absolute bottom-1.5 right-1.5 w-3.5 h-3.5 text-blue-400 dark:text-blue-500 pointer-events-none "
												viewBox="0 0 24 24"
												fill="none"
												stroke="currentColor"
												strokeWidth="2.5"
												strokeLinecap="round"
												strokeLinejoin="round"
											>
												<polyline points="9 18 15 12 9 6" />
											</svg>
										</div>
									</Tooltip>
									<MixToolTip
										content={
											<HoverMedals
												mid={id}
												data0={space.MedalsList}
											/>
										}
									>
										<div
											className="rounded-xl bg-green-50 dark:bg-[#18181b] p-2 transition-colors duration-150 hover:bg-green-100 dark:hover:bg-[#232326] cursor-pointer"
											onClick={() => {
												console.log("context menu");
												setShowMedal(!showMedal);
											}}
										>
											最高粉丝牌等级
											<br />
											<span className="font-semibold">
												{space.HighestLevel}
											</span>
										</div>
									</MixToolTip>
								</div>
							</div>
						</div>

						<div className={"mt-4 "} ref={tableRef}>
							<div className="flex  items-center flex-col sm:flex-row ">
								{!showEnter && (
									<Select
										isClearable
										onClear={() => setFilter("")}
										className="w-full sm:max-w-xs mt-4 mb-4"
										items={[
											{
												key: "1",
												value: "弹幕",
											},
											{
												key: "2",
												value: "礼物",
											},
											{
												key: "3",
												value: "大航海",
											},
											{
												key: "4",
												value: "SuperChat",
											},
										]}
										label="筛选"
										onSelectionChange={(e) => {
											setFilter(e.currentKey);
										}}
									>
										{(f) => (
											<SelectItem key={f.key}>
												{f.value}
											</SelectItem>
										)}
									</Select>
								)}

								{!cardView && (
									<Select
										isClearable
										setOrder={() => setFilter("")}
										className="mt-4 mb-4 sm:ml-4 w-full sm:max-w-xs"
										items={[
											{
												key: "gift_price_desc",
												value: "米",
											},
											{
												key: "time_desc",
												value: "时间倒序",
											},
											{
												key: "time",
												value: "时间正序",
											},
										]}
										label="排序"
										onSelectionChange={(e) => {
											console.log(e);
											setOrder(e.currentKey);
										}}
									>
										{(f) => (
											<SelectItem key={f.key}>
												{f.value}
											</SelectItem>
										)}
									</Select>
								)}
								{!showEnter && isMobile() && (
									<Autocomplete
										isClearable
										setOrder={() => setRoom("")}
										className=" mt-4 mb-4 sm:ml-4 w-full sm:max-w-xs"
										label="直播间"
										onSelectionChange={(e) => {
											setRoom(e);
										}}
										onInputChange={(e) => {
											setInput(e);
										}}
										selectedKey={room}
										items={
											space.Rooms == null
												? []
												: space.Rooms.sort((a, b) => {
														return b.Rate - a.Rate;
													}).filter((e) => {
														return e.Liver.toLowerCase().includes(
															input.toLowerCase(),
														);
													})
										}
									>
										{(f) => (
											<AutocompleteItem
												key={f.LiveRoom + ""}
												textValue={f.Liver}
											>
												<div
													className={"flex flex-row"}
												>
													<Avatar
														src={`${AVATAR_API}${f.LiverID}`}
													/>
													<span
														className={
															"font-bold ml-2 mt-2"
														}
													>
														{f.Liver}
													</span>
												</div>
											</AutocompleteItem>
										)}
									</Autocomplete>
								)}
								<div className={"w-full sm:w-auto"}>
									<Checkbox
										isSelected={showEnter}
										onValueChange={(e) => {
											setShowEnter(e);
										}}
										className="ml-2 self-start sm:self-auto mb-1 sm:mb-0"
									>
										进房
									</Checkbox>
									{true && (
										<Checkbox
											isSelected={cardView}
											onValueChange={(e) => {
												setCardView(e);
												localStorage.setItem(
													"cardView",
													e,
												);
											}}
											className="ml-2 self-start sm:self-auto mb-1 sm:mb-0"
										>
											卡片视图
										</Checkbox>
									)}
								</div>
							</div>

							{!initialActionLoaded ? (
								<div className="w-full py-16 flex items-center justify-center">
									<Spinner label="加载弹幕数据中..." />
								</div>
							) : (
								<div className="relative min-h-[200px]">
									{actionLoading && (
										<div className="absolute inset-0 z-10 flex items-center justify-center bg-white/70 dark:bg-[#18181b]/70 rounded-xl transition-opacity duration-150">
											<Spinner label="加载中..." />
										</div>
									)}
									<div
										className={`transition-opacity duration-300 ease-out ${
											actionLoading
												? "opacity-40"
												: "opacity-100"
										}`}
										style={{ willChange: "opacity" }}
									>
										{cardView ? (
											<MLiveCard
												{...raw}
												page={pageStat}
											/>
										) : (
											<ActionTable
												key={
													showEnter
														? "enter-table"
														: "action-table"
												}
												disableAvatar
												dataSource={data}
												handlePageChange={(
													page0,
													pageSize,
												) => {
													page = page0;
													setActionLoading(true);
													axios
														.get(
															`/api/actions?pb=1&uid=${id}&pn=${page0}&ps=${localStorage.getItem("defaultPageSize")}&order=${order}&type=${filter}&room=${room === null ? "" : room}&enter=${showEnter ? "1" : ""} `,
														)
														.then((response) => {
															setData(
																response.data
																	.items,
															);
															setTotal(
																response.data
																	.total,
															);
														})
														.catch((err) => {
															console.error(err);
														})
														.finally(() => {
															setActionLoading(
																false,
															);
														});
													if (page >= 2) {
														window.USER_PAGE =
															page0;
													}
													tableRef.current.parentElement.scroll(
														{
															top: 0,
															behavior: "smooth",
														},
													);
												}}
												total={total}
											/>
										)}
										{cardView ? (
											<Pagination
												initialPage={page}
												total={Math.ceil(
													total /
														parseInt(
															localStorage.getItem(
																"defaultPageSize",
															) ?? 10,
														),
												)}
												onChange={(e) => {
													setActionLoading(true);
													axios
														.get(
															`/api/actions?pb=1&uid=${id}&pn=${e}&ps=${localStorage.getItem("defaultPageSize")}&order=${order}&type=${filter}&room=${room === null ? "" : room}&enter=${showEnter ? "1" : ""} `,
														)
														.then((response) => {
															response.data.items.forEach(
																(
																	item,
																	index,
																) => {
																	if (
																		showEnter
																	) {
																		response.data.data[
																			index
																		].extra =
																			"进入直播间";
																	}
																},
															);
															setRaw(
																response.data,
															);
															setTotal(
																response.data
																	.total,
															);
															setPage(e);
														})
														.catch((err) => {
															console.error(err);
														})
														.finally(() => {
															setActionLoading(
																false,
															);
														});
													if (page >= 2) {
														window.USER_PAGE = e;
													}
													if (isMobile()) {
														window.scroll({
															top: tableRef
																.current
																.offsetTop,
															behavior: "smooth",
														});
													} else {
														rootRef.current.scroll({
															top: 0,
															behavior: "smooth",
														});
													}
												}}
											/>
										) : (
											<></>
										)}
									</div>
								</div>
							)}
						</div>
					</div>
				</div>
			)}
			{noFound && (
				<div className={"flex items-center flex-col"}>
					<img
						src={
							"https://i0.hdslb.com/bfs/new_dyn/cabcfbb4745084bec654860c582e4f491995486878.png"
						}
					/>
				</div>
			)}
		</div>
	);
}

function MLiveCard({ items, lives, page }) {
	return (
		<div>
			{lives &&
				lives.map((item) => {
					return (
						<div
							className={`${isMobile() ? "" : "w-[95%]"}`}
							key={`${item.id}`}
						>
							<LiveCard
								{...item}
								actions={items.filter(
									(x) => x.live === item.id,
								)}
							/>
						</div>
					);
				})}
		</div>
	);
}

export default UserPage;
